import { render, staticRenderFns } from "./ExpiredModal.vue?vue&type=template&id=226b62f8&scoped=true&"
import script from "./ExpiredModal.vue?vue&type=script&lang=js&"
export * from "./ExpiredModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b62f8",
  null
  
)

export default component.exports